import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup} from '@angular/forms';
import {OrderService} from '../services/order.service';
import {Company} from '../../dto/company';
import {MatStepper} from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';

import {SofortPaymentService} from '../services/sofort-payment.service';
import {NewSofortTransaction} from '../../dto/new-sofort-transaction';
import {Product} from '../../dto/product';
import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {InvoiceInfoService} from '../services/invoice-info.service';
import {ChangePaymentInfos} from '../../dto/change-payment-infos';
import {ChangePayment} from '../../dto/change-payment';
import {SofortPaymentModel} from '../../models/sofort-payment-model';


export class EmailValidation {
  static MatchEmails(ac: AbstractControl) {
    const email1 = ac.get('email').value;
    const email2 = ac.get('confirmEmail').value;

    if (email1 != email2) {
      ac.get('confirmEmail').setErrors({ mismatchPassword: true });
    } else {
      ac.get('confirmEmail').setErrors(null);
    }
  }
}


@Component({
  selector: 'change-payment',
  templateUrl: './change-payment.component.html',
  styleUrls: ['./change-payment.component.css']
})

export class ChangePaymentComponent implements OnInit {



  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private sofortPaymentService: SofortPaymentService,
    private formBuilder: FormBuilder,
    private router: Router,
    private invoiceInfoService: InvoiceInfoService,

    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe(_ => {

        this._currentLanguage = translate.currentLang;
      }
    );
    this._currentLanguage = translate.currentLang;


  }
  @ViewChild(MatStepper, { static: false }) matStepper: MatStepper;


  allowedPaymentMethods = {
    creditcard: true,
    sofort: true,
    voucher: true,
    invoice: true,
    cashOnDelivery: true,
    free: false,
  };

  allowedPaymentMethods2 = {
    creditcard: false,
    sofort: false,
    voucher: true,
    invoice: false,
    cashOnDelivery: false,
    free: false,
  };


  firstName = '';

  public productsData: Product[];
  _currentLanguage;


  stripePaymentActive: boolean;
  amountFormatted: string;
  showWebIdInfo = false;


  selectedProduct: Product = null;

  orderForm: FormGroup;

  invoiceCode: string;
  protectedOrderId: string;

  company: Company = null;
  companyId: number;
  companyName: string;
  outstandingAmount: number;
  webIdUrl: string;
  disalbleAll = false;

  removeFormControlError(control: AbstractControl, errorName: string) {
    if (control.errors && control.errors[errorName]) {
      delete control.errors[errorName];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }

  ngOnInit() {

    this.document.body.classList.add('order-assistant');


        this.protectedOrderId = this.route.snapshot.paramMap.get('orderId');


    this.orderService.getChangePaymentInfos(this.protectedOrderId).subscribe(
      (infos: ChangePaymentInfos) => {

        this.company = infos.company;
        this.companyId = infos.company.id;
        this.companyName = infos.company.name;
        this.firstName = infos.firstName;

        if ( infos.webIdTransaction ) {
          this.webIdUrl = infos.webIdTransaction.url;
        }


        this.allowedPaymentMethods = {
          creditcard: infos.company.creditCardPaymentEnabled,
          sofort: infos.company.sofortPaymentEnabled,
          voucher: false,
          invoice: infos.company.invoicePaymentEnabled,
          cashOnDelivery: false, // infos.company.cashOnDeliveryPaymentEnabled,
          free: false
        };

        this.invoiceCode = infos.invoiceCode;
        this.outstandingAmount = infos.outstandingAmount;
        this.amountFormatted = 'EUR ' + this.outstandingAmount.toFixed(2);

        this.orderForm = this.formBuilder.group(
          {
            paymentType: ''
          }
        );



      },
    (error: Error) => {
        this.disalbleAll = true;
      });














  }



  changePayment() {

    const i = new ChangePayment();
    i.orderId = this.protectedOrderId;
    i.paymentType = this.orderForm.value.paymentType.type;

    this.orderService.changePayment(i).subscribe(
      (infos: ChangePaymentInfos) => {
        if (i.paymentType === 'SOFORT') {
          const spm = new SofortPaymentModel();
          spm.invoiceCode = this.invoiceCode;
          spm.invoiceId = null;
          this.sofortPaymentService.initializeSofortPayment(spm).subscribe((newTransaction: NewSofortTransaction) => {
            window.location.href = newTransaction.paymentUrl;
          });
        } else if (i.paymentType === 'CREDIT_CARD') {
          this.stripePaymentActive = true;

          let paymentUrl = '/payment/' + this.invoiceCode + '/cc';

          if ( this.webIdUrl ) {
            paymentUrl += '?successUrl=' + encodeURIComponent(this.webIdUrl);
          } else {
            paymentUrl += '?successUrl=' + encodeURIComponent('https://cardcompact.com'); // TODO redirect to some page with a summary
          }

          paymentUrl += '&abort=' + this.protectedOrderId;

          window.location.href = paymentUrl;

        } else {
          this.showWebIdInfo = true;
        }


      }
    );





  }






  redirectToWebId() {
    window.location.href = this.webIdUrl;
  }



  showMessage(msg) {
    this.snackBar.open(msg, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }



}
